<template>
    <div
        class="help_button"
        v-if="name"
        @click="clicked(name)"
    >
        ?
    </div>

</template>

<script>
/**
 * ヘルプボタン
 * [プロパティ]
 * name ... ヘルプのキー
 * 
 * [イベント処理]
 * クリック時 ... this.$emit('click', name)
 * 
 * [利用例]
 * <help-button
 *     :name="name"
 *     @click="clicked(name)"
 *     class="bigger_button"
 * />
 */
export default {
    name:"HelpButton",
    props: {
        /**
         * ヘルプのキー
         */
        name: {
            type:String
        },
    },
    methods:{
        /**
         * クリックイベントの発生を親コンポーネントに伝える
         */
        clicked(name){
            this.$emit('click', name)
        }
    }
}
</script>

<style scoped>
div.help_button{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    margin: 0 16px;
    padding: 2px;
    font-size: 12px;
    line-height: 12px;
    font-weight: bolder;
    text-align: center;
    color: white;
    background-color: #178EAA;
    border-radius: 8px;
    border: none;
    box-shadow: none;
    cursor:pointer;
    margin:0 0.25rem;
}
/* app-boxの中でだけサイズを変える */
div.bigger_button{
    width:18px;
    height:18px;
    font-size:14px;
    line-height:14px;
}
div.rotate{
    margin:0.25rem 0;
    transform: rotateZ(-90deg);
}

_:-ms-lang(x)::-ms-backdrop, div.help_button {
    padding: 4px 0 0;
}

_:-ms-lang(x)::-ms-backdrop, div.rotate {
    padding: 0 4px 0 0;
}
</style>